export abstract class ListMaintenanceDto {
    public __order: string;
    public __id: string;
    public __key: string;
}